import { useState } from 'react';
import { Box, Tab } from '@mui/material';
import PageContent from '@bumble/app/components/PageContent';
import { TabPanel, TabContext, TabList } from '@mui/lab';
import { LinkUtilizationDashboard } from './LinkUtilizationDashboard';
import { ApplicationHighlightsDashboard } from './ApplicationHighlightsDashboard';
import { WANLinkHealthDashboard } from './WANLinkHealthDashboard';
import { SecurityServicesDashboard } from './SecurityServicesDashboard';
import { MapDashboard } from './MapDashboard';
import { CpeProvider } from './CpeContext';

export interface CardInfo {
  name: string;
  count: number;
  primaryColor: string;
  secondaryColor: string;
};

export interface RegionInfo {
  name: string;
  latitude: number;
  longitude: number;
  data: object;
};

export const IspDashboard = () => {
  const [value, setValue] = useState('1');
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <CpeProvider>
      <PageContent>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleChange} aria-label="Dashboard Tabs" TabIndicatorProps={{sx: { bgcolor: '#EABF4E'}}}>
              <Tab label="Map View" value="1" />
              <Tab label="WAN Link Health" value="2" />
              <Tab label="WAN Link Utilization" value="3" />
              <Tab label="Application Performance Insights" value="4" />
              <Tab label="DDoS Protection Suite" value="5" />
            </TabList>
          </Box>
          <TabPanel value="1">
            <MapDashboard />
          </TabPanel>
          <TabPanel value="2">
            <WANLinkHealthDashboard selectedTab={value} />
          </TabPanel>
          <TabPanel value="3">
            <LinkUtilizationDashboard selectedTab={value} />
          </TabPanel>
          <TabPanel value="4">
            <ApplicationHighlightsDashboard selectedTab={value} />
          </TabPanel>
          <TabPanel value="5">
            <SecurityServicesDashboard selectedTab={value} />
          </TabPanel>
        </TabContext>
      </PageContent>
    </CpeProvider>
  );
};
